import React, { forwardRef } from 'react';

import { Private } from '../security/Private';
import { Input, type InputProps } from './Input';

export const PrivateInput = forwardRef<
    React.ElementRef<typeof Input>,
    InputProps
>((props, ref) => {
    return (
        <Private>
            <Input ref={ref} {...props} />
        </Private>
    );
});
